import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: config.serverUrl,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const facebookShopApi = {
  postCatalogConnect: (request) => {
    const { data } = request
    return instance().post(`/api/cms/v1/facebook-catalog/connect`, data)
  },
  deleteCatalogConnect: (request) => {
    const { pageId } = request
    return instance().delete(`/api/cms/v1/facebook-catalog/disconnect?page_id=${pageId}`)
  },
  syncProduct: (request) => {
    const { data } = request
    return instance().post(`/api/cms/v1/facebook-catalog/sync-product`, data)
  },
  unSyncProduct: (request) => {
    const { data } = request
    return instance().delete(`/api/cms/v1/facebook-catalog/unsync-product`, { data })
  },
  // Tero
  syncProductTero: (request) => {
    const { data } = request
    return instance().post(`/tero/facebook-catalog/sync-product`, data)
  }
}

export default facebookShopApi



// WEBPACK FOOTER //
// ./src/api/facebook-shop.js